import styled from "styled-components";
import { FiChevronsLeft } from "react-icons/fi";
import { FiChevronLeft } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";
import { FiChevronsRight } from "react-icons/fi";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 0px;
`;

export const PageLabel = styled.span`
  margin-left: 20px;
  margin-right: 20px;
  font-size: 15px;
  cursor: default;
`;

export const ArrowLeft = styled(FiChevronLeft)`
  margin-left: 10px;
  cursor: pointer;
`;

export const ArrowsLeft = styled(FiChevronsLeft)`
  margin-left: 10px;
  cursor: pointer;
`;

export const ArrowRight = styled(FiChevronRight)`
  margin-right: 10px;
  cursor: pointer;
`;

export const ArrowsRight = styled(FiChevronsRight)`
  margin-right: 10px;
  cursor: pointer;
`;

export const Container2 = styled.div`
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    padding: 0px;
    font-size: 12px;
  }

  .pagination li a {
    display: block;
    padding: 8px 12px;
    text-decoration: none;
    /* border: 1px solid gray; */
    color: #fff;
    /* margin: 0 4px; */
    /* border-radius: 5px; */
  }

  .pagination li a.active {
    background-color: #4caf50;
    border-radius: 3px;
    color: white;
  }
`;
